import styles from "./styles.module.scss";
import { Box } from "@mui/material";

const ViewDoc = ({ docurl }: { docurl: string }) => {
	const extension = docurl.split(".").pop();

	return (
		<Box className={styles.viewDocModal}>
			<img
				src={docurl}
				alt="document Image"
				style={{
					minHeight: "300px",
					minWidth: "300px",
				}}
			/>
		</Box>
	);
};

export default ViewDoc;
